module.exports = __webpack_public_path__ + "img/711.ec930296.jpg";